/*
  "In this article" for the Article Template. Rendered by sections/main-article.liquid only when
  the body has 3+ H2s. Legacy H2s have no ids, so this slugifies their text, assigns unique ids
  and builds the collapsible list.
*/
(function () {
  var toc = document.querySelector('[data-pwb-toc]');
  if (!toc) return;
  var list = toc.querySelector('ol');
  var headings = document.querySelectorAll('[data-pwb-body] h2');
  if (headings.length < 3) return;

  var used = {};
  function slugify(text) {
    var base = text.toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9\s-]/g, '').trim().replace(/\s+/g, '-').replace(/-+/g, '-').slice(0, 60) || 'section';
    var slug = base, n = 2;
    while (used[slug] || (document.getElementById(slug) && !used[slug])) slug = base + '-' + n++;
    used[slug] = true;
    return slug;
  }

  headings.forEach(function (h2) {
    var text = (h2.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return;
    if (!h2.id) h2.id = slugify(text);
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h2.id;
    a.textContent = text;
    li.appendChild(a);
    list.appendChild(li);
  });

  if (list.children.length >= 3) toc.hidden = false;
})();
